import { t } from '../../services/localization';

export const formatDuration = (
    duration: moment.Duration,
    options: {
        omitSeconds?: boolean;
        omitMinutes?: boolean;
        omitHours?: boolean;
        omitDays?: boolean;
    } = {}
) => {
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    let fragments = [];

    if (days && !options.omitDays) {
        fragments.push(t('days_plural_one_day_other_days', { days }));
    }

    if (hours && !options.omitHours) {
        fragments.push(t('hours_plural_one_hour_other_hours', { hours }));
    }

    if (minutes && !options.omitMinutes) {
        fragments.push(t('minutes_plural_one_minute_other_minutes', { minutes }));
    }

    if (seconds && !options.omitSeconds) {
        fragments.push(t('seconds_plural_one_second_other_seconds', { seconds }));
    }

    if (fragments.length === 0) {
        return t('less_than_second');
    }

    return fragments.join(' ');
};
